<template>

    <div class="unavailable">

        <div class="housework">
            <img src="/img/newsletters-v2/foxy-housework.svg">
        </div>

        <p class="title">{{$t('sorting_unavailable')}}</p>

        <p class="text">{{$t('email_provider_no_access')}}</p>

        <button class="cta-unavailable" @click="addMailbox">{{$t('settings_new_mailbox')}}</button>

    </div>

</template>

<script>
import Tag from '../../modules/tag'

export default {

    name: 'unavailable',

    mounted() {
        Tag.pageViewAll(this, this.page)
    },

    data() {
        return {
            page: 'newsletter_sort_shutdown'
        }
    },

    methods: {

        addMailbox() {
            Tag.clickAll(this, 'add_inbox', null, this.page)
            this.$router.push({path: '/add-inbox'})
        }
    }
}
</script>

<style lang="scss" scoped>

.unavailable {
    background-color: $timberwolf;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 16px;
    text-align: center;
    align-items: center;
    justify-content: center;

    .housework {
        width: 80px;
        height: 80px;
        display: flex;
        align-content: center;
        justify-content: center;
        border-radius: 100%;
        background-color: $forest;
        overflow: hidden;

        > img {
            height: 75px;
            object-fit: contain;
        }
    }

    .title {
        margin-top: 8px;
        font-size: 17px;
        font-weight: 500;
    }

    .text {
        margin-top: 8px;
        font-size: 15px;
        font-weight: 400;
        color: $neutralsMoon;
    }

    .cta-unavailable {
        margin-top: 24px;
        padding: 6px 14px;
        border-radius: 64px;
        border: 2px solid $neutralsPlatinum;
        background: $white;
        width: fit-content;
        font-size: 15px;
        font-weight: 500;
    }
}
</style>
